<template>
  <div class="streamer-agent">
    <!-- 侧边栏与主内容区 -->
    <div class="flex max-w-7xl mx-auto px-4 py-8">
      <!-- 侧边栏 -->
      <aside class="w-56 mr-8 hidden md:block">
        <nav class="space-y-2">
          <a 
            v-for="(section, index) in sections" 
            :key="index"
            :href="`#${section.id}`"
            :class="[
              'block px-4 py-2 rounded-lg',
              activeSection === section.id 
                ? 'bg-purple-50 text-purple-700 font-bold' 
                : 'hover:bg-purple-50'
            ]"
            @click.prevent="scrollToSection(section.id)"
          >
            {{ $store.getters.t(section.label) }}
          </a>
        </nav>
      </aside>
      
      <!-- 主内容区 -->
      <main class="flex-1 space-y-8">
        <!-- 开播准备 -->
        <section id="prepare" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-list text-purple-600 mr-2"></i>
              {{ $store.getters.t('prepare') }}
            </h2>
            <button class="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700">
              <i class="fas fa-plus mr-2"></i>
              {{ $store.getters.t('add_prepare') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('prepare_desc') }}</p>
          <button class="bg-purple-100 text-purple-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-purple-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_prepare') }}
          </button>
        </section>
        
        <!-- 设备/软件采购 -->
        <section id="device" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-shopping-cart text-green-600 mr-2"></i>
              {{ $store.getters.t('device_purchase') }}
            </h2>
            <button class="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
              <i class="fas fa-plus mr-2"></i>
              {{ $store.getters.t('add_device') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('device_desc') }}</p>
          <button class="bg-green-100 text-green-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-green-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_device') }}
          </button>
        </section>
        
        <!-- 开播测试/试播 -->
        <section id="test" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-vial text-blue-600 mr-2"></i>
              {{ $store.getters.t('test') }}
            </h2>
            <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
              <i class="fas fa-play mr-2"></i>
              {{ $store.getters.t('start_test') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('test_desc') }}</p>
          <button class="bg-blue-100 text-blue-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-blue-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_test') }}
          </button>
        </section>
        
        <!-- 正式开播 -->
        <section id="start" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-broadcast-tower text-yellow-600 mr-2"></i>
              {{ $store.getters.t('start') }}
            </h2>
            <button class="bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700">
              <i class="fas fa-video mr-2"></i>
              {{ $store.getters.t('go_live') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('start_desc') }}</p>
          <button class="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-yellow-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_live') }}
          </button>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StreamerAgent',
  data() {
    return {
      activeSection: 'prepare',
      sections: [
        { id: 'prepare', label: 'prepare' },
        { id: 'device', label: 'device_purchase' },
        { id: 'test', label: 'test' },
        { id: 'start', label: 'start' }
      ]
    }
  },
  methods: {
    scrollToSection(sectionId) {
      this.activeSection = sectionId
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleScroll() {
      const sections = this.sections
      const scrollPosition = window.scrollY + 100

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i].id)
        if (section && section.offsetTop <= scrollPosition) {
          this.activeSection = sections[i].id
          break
        }
      }
    }
  },
  mounted() {
    // 监听滚动事件，更新活动区域
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
.streamer-agent {
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.card-hover {
  transition: all 0.3s ease;
}

.card-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.space-y-8 > * + * {
  margin-top: 2rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.text-xl {
  font-size: 1.25rem;
}

.font-bold {
  font-weight: 700;
}

.text-gray-600 {
  color: #4b5563;
}

.text-purple-600 {
  color: #9333ea;
}

.text-green-600 {
  color: #16a34a;
}

.text-blue-600 {
  color: #2563eb;
}

.text-yellow-600 {
  color: #ca8a04;
}

.bg-purple-600 {
  background-color: #9333ea;
}

.bg-green-600 {
  background-color: #16a34a;
}

.bg-blue-600 {
  background-color: #2563eb;
}

.bg-yellow-600 {
  background-color: #ca8a04;
}

.hover\:bg-purple-700:hover {
  background-color: #7c3aed;
}

.hover\:bg-green-700:hover {
  background-color: #15803d;
}

.hover\:bg-blue-700:hover {
  background-color: #1d4ed8;
}

.hover\:bg-yellow-700:hover {
  background-color: #a16207;
}

.text-white {
  color: #ffffff;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.text-sm {
  font-size: 0.875rem;
}

.bg-purple-100 {
  background-color: #f3e8ff;
}

.bg-green-100 {
  background-color: #dcfce7;
}

.bg-blue-100 {
  background-color: #dbeafe;
}

.bg-yellow-100 {
  background-color: #fef3c7;
}

.text-purple-700 {
  color: #7c3aed;
}

.text-green-700 {
  color: #15803d;
}

.text-blue-700 {
  color: #1d4ed8;
}

.text-yellow-700 {
  color: #a16207;
}

.hover\:bg-purple-200:hover {
  background-color: #e9d5ff;
}

.hover\:bg-green-200:hover {
  background-color: #bbf7d0;
}

.hover\:bg-blue-200:hover {
  background-color: #bfdbfe;
}

.hover\:bg-yellow-200:hover {
  background-color: #fde68a;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.bg-purple-50 {
  background-color: #faf5ff;
}

.hover\:bg-purple-50:hover {
  background-color: #faf5ff;
}

.text-purple-700 {
  color: #7c3aed;
}

.space-y-2 > * + * {
  margin-top: 0.5rem;
}

.w-56 {
  width: 14rem;
}

.mr-8 {
  margin-right: 2rem;
}

.hidden {
  display: none;
}

@media (min-width: 768px) {
  .md\:block {
    display: block;
  }
}

.flex-1 {
  flex: 1 1 0%;
}
</style> 